import Home from '../containers/Home/Home'
import Sex from '../containers/Sex/Sex'
import Age from '../containers/Age/Age'
import Problem from '../containers/Problem/Problem'
import Often from '../containers/Often/Often'
import Amount from '../containers/Amount/Amount'
import Diaper from '../containers/Diaper/Diaper'
import Day from '../containers/Day/Day'
import Help from '../containers/Help/Help'
import Faq from '../containers/Faq/Faq'
import Conclusion from '../containers/Conclusion/Conclusion'
import NoMatch from '../components/NoMatch/NoMatch'

const routes = [
  {
    path: '/',
    exact: true,
    component: Home
  },
  {
    path: '/steg/barnets-kjonn',
    exact: true,
    component: Sex
  },
  {
    path: '/steg/barnets-alder',
    exact: true,
    component: Age
  },
  {
    path: '/steg/oppleves-det-som-et-problem',
    exact: true,
    component: Problem
  },
  {
    path: '/steg/hvor-ofte',
    exact: true,
    component: Often
  },
  {
    path: '/steg/hvor-mye',
    exact: true,
    component: Amount
  },
  {
    path: '/steg/bruker-bleie',
    exact: true,
    component: Diaper
  },
  {
    path: '/steg/skjer-pa-dagen',
    exact: true,
    component: Day
  },
  {
    path: '/steg/oppsokt-hjelp',
    exact: true,
    component: Help
  },
  {
    path: '/steg/konklusjon',
    exact: true,
    component: Conclusion
  },
  {
    path: '/faq',
    exact: true,
    component: Faq
  },
  {
    component: NoMatch
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes/index.js